import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { selectUserAssignment } from 'actions/view'

const Tag = ({
	classes,
	users,
	currentUser,
	userAssignment,
	selectUserAssignment,
}) => {
	const user = users?.[userAssignment?.slice?.(11)]
	const tagLabel =
		user?.user_name === currentUser
			? 'My contacts'
			: `${user?.first_name || ''} ${user?.last_name || ''} Contacts`

	return (
		<div className={classes.tagContainer}>
			<div
				className={classes.tag}
				style={{ backgroundColor: '#006fd9', color: '#fff', borderRadius: 20 }}
			>
				<Typography noWrap className={classes.tagTypography}>
					{!userAssignment && 'All contacts'}
					{userAssignment === 'contact/a2' && 'Unassigned contacts'}
					{userAssignment && userAssignment !== 'contact/a2' && tagLabel}
				</Typography>
				{userAssignment && (
					<Close
						style={{
							cursor: 'pointer',
							marginLeft: 5,
							verticalAlign: 'top',
						}}
						onClick={() => selectUserAssignment()}
					/>
				)}
			</div>
		</div>
	)
}

const styles = (theme) => ({
	tag: {
		color: '#fff',
		[theme.breakpoints.down('xs')]: {
			padding: '6px 8px',
		},
		[theme.breakpoints.up('sm')]: {
			padding: '8px',
		},
	},
	tagContainer: {
		paddingLeft: 4,
		[theme.breakpoints.down('xs')]: {
			paddingTop: 2,
		},
	},
	tagTypography: {
		color: '#fff',
		fontSize: theme.typography.pxToRem(15),
		maxWidth: 'calc(100vw - 445px)',
		display: 'inline-block',
		[theme.breakpoints.down('sm')]: {
			maxWidth: 'calc(100vw - 425px)',
		},
		[theme.breakpoints.down('xs')]: {
			maxWidth: 'calc(100vw - 320px)',
		},
	},
})

export default connect(
	(state) => ({
		users: state.data['account/user'] || {},
		currentUser: state?.auth?.session?.idToken?.payload?.['cognito:username'],
		userAssignment: state?.sort?.userAssignment,
	}),
	(dispatch) => bindActionCreators({ selectUserAssignment }, dispatch),
)(withStyles(styles)(Tag))
